import { BalanceTransactionsProvider } from '@talos/kyoko';
import type { PropsWithChildren } from 'react';

export const GCashBalanceTransactionProvider = ({ children }: PropsWithChildren) => {
  return <BalanceTransactionsProvider shouldHaveOpenSubscription>{children}</BalanceTransactionsProvider>;
};
